module.exports = __webpack_public_path__ + "img/ASFT_visualisoinnit_muokatut-07.c43a20fc.png";